import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { OneSignal } from 'onesignal-ngx';
import { forkJoin, Subject, takeUntil } from 'rxjs';
import { AuthenticationService } from 'src/app/core/services/auth/authentication.service';
import { DashboardService } from 'src/app/core/services/dashboard/dashboard.service';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { LocalStorageService } from 'src/app/core/services/localStorage/localStorage.service';
import { OptionsService } from 'src/app/core/services/options/options.service';
import { UniversityCommunicationService } from 'src/app/core/services/university-communication/university-communication.service';
import { environment } from 'src/environments/environment';
import * as powerbi from 'powerbi-client';
import moment from 'moment';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {
  @ViewChild('reportContainer', { static: true }) reportContainer!: ElementRef;
  counts: any;
  private _unsubscribeAll: Subject<any> = new Subject();
  userDetails: any;
  mailDynamicData: any = [];
  powerBiToken:any;
  powerBiFilters: any = {};
  showRMDashboard: boolean = false;
  constructor(
    private _dashboardService: DashboardService,
    private _loaderService: LoaderService,
    private oneSignal: OneSignal,
    private _optionService: OptionsService,
    private _authService: AuthenticationService,
    private _lc: LocalStorageService,
    private _universitycommunicationService: UniversityCommunicationService,
  ) { }

  ngOnInit(): void {
    this.userDetails = this._authService.getLoginUserDetails();
    this.oneSignalInit();
    this.getDashboardCounts();
    // this.embedReport();
    this.getEmbededToken();
    this.isRM();
    this.powerBiFilters = {
      userName: this.userDetails?.name,
      thirtyDaysAgo:moment().subtract(30, 'days').format('MM/DD/YYYY'),
      currentDay:moment().format('MM/DD/YYYY'),
    }
  }

  getDashboardCounts() {
    if (true) {
      this._loaderService.showLoader();
      this._dashboardService.getDashboardCounts()
        .pipe(takeUntil(this._unsubscribeAll)).
        subscribe(res => {
          this.counts = res?.data;
          this.checkMailDetails();
          this._loaderService.hideLoader();
        }, (err) => {
          this._loaderService.hideLoader();
        })
    }
  }

  oneSignalInit() {
    this.oneSignal.init({
      appId: environment?.oneSignalAppId, //? mail.crizac.com
      // appId:'0da6bcf9-4fc0-4282-afba-3c8c152bc51a', //? mail-dev.crizac.com
      // appId: "6e77738a-dea8-49a3-9f9e-c477d86f9847", //? localhost 4202
      serviceWorkerParam: {
        scope: '/'
      },
      serviceWorkerPath: './OneSignalSDKWorker.js'
    }).then((rsv) => {
      // do other stuff
      console.log({ Connected: rsv });
      // this.handleSubscription();
      console.log(this.oneSignal.User.PushSubscription.id);
      if (this.oneSignal.Notifications.isPushSupported() && this.oneSignal.User.PushSubscription.id) { //? checking support  
        let payload = { userId: this.userDetails.id, playerId: this.oneSignal.User.PushSubscription.id, deviceType: '115' }
        this._optionService.oneSignalSubscribe(payload)
          .subscribe((rsv) => {
            console.log(rsv);
          })
      }
    });
  }

  checkMailDetails() {
    if (!this._lc.getUserMailDetails()) {
      if(!this.userDetails?.inboxMail?.length){
        return;
      }
      let mailSignatureDetails = this.userDetails?.inboxMail?.map((mail) => {
        let email = mail?.mail;
        email = email?.split("@")[1];
        return { domain: email }
      });
      let composeEmailIds = this.userDetails?.composeEmailIds?.split(',')?.map((mail) => {
        let email = mail;
        email = email?.split("@")[1];
        return { domain: email }
      });
      mailSignatureDetails = [
        ...mailSignatureDetails,
        ...composeEmailIds
      ]
      const uniqueEmails = new Set();
      const uniqueEmailObjects = mailSignatureDetails?.filter((element) => {
        if (!uniqueEmails.has(element.domain)) {
          uniqueEmails.add(element.domain);
          return true; // Include this object in the unique array
        }
        return false; // Skip duplicates
      });
      // console.log("Unique Email Objects:", uniqueEmailObjects);
      const apiCalls: any = uniqueEmailObjects?.map((element) =>
        this._universitycommunicationService.getDynamicMailSignature(element?.domain)
      );
      forkJoin(apiCalls).subscribe({
        next: (responses: any) => {
          this.mailDynamicData = responses?.map((rsv, index) => {
            const data = rsv?.data;
            const companyName = data?.find((v) => v?.key === "config_name")?.value;
            const companyWebsite = data?.find((v) => v?.key === "config_url")?.value;
            const companyPhone = data?.find((v) => v?.key === "config_telephone")?.value;
            const companyAddress = data?.find((v) => v?.key === "config_address")?.value;
            const companyImage = rsv?.image;
            return {
              domain: uniqueEmailObjects[index]?.domain,
              companyName: companyName,
              companyWebsite: this.extractDomain(companyWebsite),
              companyPhone: companyPhone,
              companyImage: companyImage,
              companyAddress: companyAddress
            };
          });
          // console.log("Mail Dynamic Data:", this.mailDynamicData);
          this._lc.setUserMailDetails(this.mailDynamicData);
        },
        error: (error) => {
          // console.error("Error during API calls:", error);
        },
      });
    }
  }

  extractDomain(url) {
    // Remove protocol (http://, https://, etc.)
    let domain = url?.replace(/^https?:\/\//, '');
    // Remove path, query parameters, etc.
    domain = domain?.split('/')[0];
    return domain;
  }


  // embedReport() {
  //   // ⚠️ Replace these values with actual ones
  //   const embedToken = 'H4sIAAAAAAAEACWUx66DVgBE_-VtiUTHl0hZUEw3cOl4R-8dYyDKv-cpmeXMrI5G8_ePnVz9lOQ_f_58B-EV7hjIn0sSau8Cr18uvSzhh2_M4JEcmrxkwIRPva79x3yg2Ocot3b0naSM1VrrGcDW3ho6qauw7NRibBd0narCXJOUnHlaZoykm_-NWhvwnz558MbAfRHyYG9-tSrkRnlem4x1CtyXnjD3g8brw8uXavFU2I0KlsU7QxbYbOc8KDM9RSfirORK0ON2wHKsLawQemGn17bUEPfpGh62S85sy1LKPJnmXKATFp4A6uqxb16IoGFnXIrgsErAUGtahponjPokWulZ7-EphjzzNssbe-MxpU0gF19Max5o3iKfZ2QdAbRT8wWHgx0zLuB1wMm3i84IK87bS7obQr9d65az0Pm-C1gpwPTrh5eJnfkSZzfAQyFhzvdNJJEugbnkM3qhpiYS-l5WQ4coIlTOSsMhQufAYqjS8he__TTtBTOTg-lWF4cf9zGQ7IPq3Gs9uAaOi4xoDcbq59LzG9ROsrIiqfPw3nZ_JdmRcEyHKcU-pJEXkx7FvV66f2X5Lr2Ks7AboLOFqUStOMb1gl7KTpNSapCZIAhvvv1chhisdT812stzpAdak4pWPfujZdLf0GObsDnNkAJWeKmkZhnPeqGKxbmCIOp4lpnowQBBskiPmKO06L7c0U25LbVHsQAVtI5xUUgcNUhdSgSHxD-ruulFZRli1DoUqefcodEh9ZG5REaHh5J31q_1oU2vYQ9CtHztAtf9vtiAViu5XjxvT86RdhTabGLeLvu2vFhWEJ9__fzxI6zXvE96cf1O_wWQk1ATa5Wnz0xkzOg_jQTzKat3-b4XTraENrsZ8LN3DBhgwpG41tXkE3bmZJr3_IyTty16eVxMiJeLgZCplwaHM2JgHIYZRSm55cYC_tDfchevQd3JC4q-EnzoT9a65Mo7zDqan89EuYEKBU3B_Wvhl4kyOTltCbe2wcHcyftu7YCUR16xp7vhrwqnX1l9fLcmm9tpUrwowSxCmX1s62Q173P60-w-TPDPV_qqFsIke0IMR8biDjba-EX4Wz-r_Pjt39dejPyCnuzFn2g6vxVIx-DevgqAiTrUeAtqFvq3Z6WQMSRxaIsVfPR872UmyeIWyeMyD8yA0tDTGQhRFb3qr_8wX3NdrGrwS5l7WYzred-qvJe5qU64wjD6v-U21Zjsn7X4rYVSisIcyiaUEbY-NX19uD3Sd-6WYpvRWC9uRR1C-PrlZIwaYk0hGK-ydCeNPHm6YUnyWmLHmxF_MW0ozIFx9epZrD5xJIIfTLyyz-4gBqHLPc1se_uy-BVp_2PwqWdt-bQt4V5cW-DbZSCHQd8ZPT1RYMAYagIzBs_iUBHvCIwmGsY-zxDHVPcCtHqNCgt2lctghg-UaJeL32bRFj-MZoxvDHFaCQMAVb3fS511S0-8VKmwqD5KOblRcctNoAMblbwMH98NWQqRSGkcRB5PnaRBVoXqxDooQM-kBuQB6uArnQP6Kr7LEKDTpNbAd7XjOEnuKjzrEmZxVp5deU846Y7cL-Z__gWpZVOr7gUAAA==.eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLUlORElBLUNFTlRSQUwtQS1QUklNQVJZLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZXhwIjoxNzQxNjc5NzI4LCJhbGxvd0FjY2Vzc092ZXJQdWJsaWNJbnRlcm5ldCI6dHJ1ZX0='; // From Power BI Service or backend
  //   const embedUrl = 'https://app.powerbi.com/reportEmbed?reportId=8be5d7b6-3c38-4287-94dc-39f202447a94&groupId=120f234a-0fe5-4efb-9ef7-d73332d10e55';
  //   const reportId = '8be5d7b6-3c38-4287-94dc-39f202447a94';

  //   const embedConfig: powerbi.IEmbedConfiguration = {
  //     type: 'report',
  //     id: reportId,
  //     embedUrl: embedUrl,
  //     accessToken: embedToken,
  //     tokenType: powerbi.models.TokenType.Embed,
  //     settings: {
  //       panes: {
  //         filters: { visible: false }, // Hide filter pane
  //         pageNavigation: { visible: false }, // Hide page navigation
  //       },
  //       navContentPaneEnabled: false, // Hide left navigation pane
  //       background: powerbi.models.BackgroundType.Transparent, // Optional: transparent background
  //     },
  //     pageName: 'eeb442359c4886af40c9'
  //   };

  //   const powerbiService = new service.Service(powerbi.factories.hpmFactory, powerbi.factories.wpmpFactory, powerbi.factories.routerFactory);
  //   const report = powerbiService.embed(this.reportContainer.nativeElement, embedConfig);
  //   // const report = powerbi.embed(this.reportContainer.nativeElement, embedConfig);

  //   // Optional: handle events
  //   report.on('loaded', () => {
  //     console.log('Report loaded successfully');
  //   });

  //   report.on('error', (event) => {
  //     console.error('Error embedding report:', event.detail);
  //   });
  // }

  embedReport() {
    const embedToken = 'H4sIAAAAAAAEACWUt660aAJE3-WmrIR3K_0B3ntPBnxAYxrbQMNo3n3vzkSVnOhUqf76cYt7nAvw89-fiHA3ggsv1keT8cwveqw5rLk0mtmM-ZCRtzqQFDs0bCdjdiDhhI5FzhR2xVijcSlhOLJxyxdZm2bm5i0q2xapguomCNPenZYfmwpC09S5YZpfzOhjZly2YS1G4MtcT6oGBf7hje-bIPPQ5m41DrAl8wJlWk2OpeoRFD0-iUNGNWh6cPnXyFUpXPx4n_HyPe7QZ2xg9ZiX66UVq6-IgU19QsuFPR2dA50wJCFEZkQqqaoGMJp8yMgdKqbfNwJEO-u7XMRLtyyBJ1hqYPn1rkn4J108HTsJkX0qm30_Vw9FB9IEfGAiqqyucVE0tGyz3yYhNCN1qsxbKEDQBxxzZ3vwnWSGYtml316x9MxU0-_30MFIGxIUr4vfrFb16fRLHeU3gMuXPDCa7IbMdPHM0PM0i5pNPF3Wh87bEfWtVtz6mxdy5_wilaXzqp5AsmlMSakOA6mCO2JlwcA5WktN9Tm5WEYU5MBx7ChM7AIgyrpruhJNzd8CtJOW0TK4FjLMYZop7NvTK8rvkTdo8Z24JxjwjzRm1Riyqsih_A21Ac8A8xJssZm2gzLyr59W0VN3rl52zFnqkDTqRPxoKzmt3Bl0GAQw37GRty48NTRrHXTgx5uD2THW3ePDpaqUeRLrE3ku9wspd_i0ZO-x721rc0WRZLGYJ63ZGK0Jyg2KVJdsmRfXdbTL_Y0-g4JU1ydvWJ1H2SuBHJNZxaCXiN9SbPXGiNeKOVQrgjffpfE0CWHtWlZF4s_Pf36E7V4-s1Hfv9NHwm2CsNw0-06TRQuSgpTADx1eVOPo1ee3vXY15Ad4mK6GsJzH9d3rJF71w3eHJhtCroUy3InvPawM0XC2hNGeLNO_XDltJOvssEVPGBtJ9XFi95d0k0zsTEhApOI0d27DfSImbqAIoZyTvebjrlybhr6lBVKbggZ1d7TYOEC6aGTnD2bhHlg2WW50M0-Sho3ZlmGo39HiNSCPLcVWr0l80c6xcgS-P8xRwZ0wweMOd1Yw9oGmQE9UkGXTl-Nda3YmhoQe-Ppmi_I7vEkds5gF39cjrqiy2cvXt_b8Flg1PkQ3CKDyaPQEV4r-CxpM4LcNyF1uyi9ozssljeiGHcrtc_35R_O9vOpNi38tj2iqo9_VkhGjlG4XeVnM7fxLBV07FZ9jq38xK0V2_j5T8GbEoURi5VZCklupIMcs4fUYrg71QiocNBNTU3JxGTa_qsLe1Vhv6bfgHbGZgMp6qeXUfi69RM9UwWiCDY3UTf0enDuz1LkkJTqFu9qt1a_tmcHBb1l1lx3mo9ivkEhp2Mf2FKZAvQ_KyOfRXJdv9ZE5ngiFAG_L6dznlQVEogBq5OX0K5r1F6oWvD_IKSW7zgY8g5IcW80FY9I0rQsYZvWK6hDcZVcKkEM-JbFwRzhMV_x-2al-d5g13yulPLAaJhU398bCUW_3Pscizx5c8nRIhBPgQk_cRsTnduTGa5uolbvjayHpgtBMclIPjHsaN-q8PWdcr12_H_F_zX__D3hfHYDuBQAA.eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLUlORElBLUNFTlRSQUwtQS1QUklNQVJZLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZXhwIjoxNzQxNjg1NzY0LCJhbGxvd0FjY2Vzc092ZXJQdWJsaWNJbnRlcm5ldCI6dHJ1ZX0='; // Dynamic from backend
    const embedUrl = 'https://app.powerbi.com/reportEmbed?reportId=8be5d7b6-3c38-4287-94dc-39f202447a94&groupId=120f234a-0fe5-4efb-9ef7-d73332d10e55';
    const reportId = '8be5d7b6-3c38-4287-94dc-39f202447a94';
    // const pageName = 'd3e4ca6d96e9d32635e3'; // Target page ID
    const pageName = 'd2a5c81b97c045c23453';
    
    const embedConfig: powerbi.IEmbedConfiguration = {
      type: 'report',
      id: reportId,
      embedUrl: embedUrl,
      accessToken: embedToken,
      tokenType: powerbi.models.TokenType.Embed,
      settings: {
        panes: {
          filters: { visible: false }, // Hide filters
          pageNavigation: { visible: false } // Hide page nav
        },
        navContentPaneEnabled: false
      }
    };

    const powerbiService = new powerbi.service.Service(powerbi.factories.hpmFactory, powerbi.factories.wpmpFactory, powerbi.factories.routerFactory);

    // Embed report
    const report = powerbiService.embed(this.reportContainer.nativeElement, embedConfig) as powerbi.Report;
    let isPageSet = false; // ✅ Prevent recursive call

    // When report is fully loaded
    report.on('loaded', () => {
      console.log('Report loaded');
    });

    // When visuals are rendered and ready
    report.on('rendered', async () => {
      console.log('Report rendered and ready');
      if (isPageSet) return; // Prevent repeated execution
      try {
        const pages = await report.getPages();
        console.log('Pages:', pages.map(p => p.name));

        const targetPage = pages.find(page => page.name === pageName);
        if (targetPage) {
          await targetPage.setActive();
          // console.log(Page set to ${pageName});
          isPageSet = true; // ✅ Set flag to stop re-running
        } else {
          // console.warn(Page ${pageName} not found);
        }
      } catch (error) {
        console.error('Failed to set active page:', error);
      }
    });

    // Handle errors
    report.on('error', (event) => {
      console.error('Power BI Embed Error:', event.detail);
    });
  }

  getEmbededToken(){
    this._dashboardService.getPowerBiToken()
    .subscribe((v)=>{
      // console.log(v);
      this.powerBiToken = v?.token;
    })
  }
  
  showJuniorCPTReports() {
    if(this.userDetails?.roles?.[0]?.id === "130" || this.userDetails?.roles?.[0]?.id === "149" || this.userDetails?.roles?.[0]?.id === "47" || this.userDetails?.roles?.[0]?.id === "20"){
      return true;
    }else{
      return false;
    }
  }

  showSeniorCPTReports() {
    if(this.userDetails?.roles?.[0]?.id === "47" || this.userDetails?.roles?.[0]?.id === "20"  || this.userDetails?.roles?.[0]?.id === "149" || this.userDetails?.roles?.[0]?.id === "152" || this.userDetails?.roles?.[0]?.id === "78"){
      return true;
    }else{
      return false;
    }
  }

  showToOnlySeniors(){
    if(this.userDetails?.roles?.[0]?.id === "47" || this.userDetails?.roles?.[0]?.id === "20"  || this.userDetails?.roles?.[0]?.id === "118" || this.userDetails?.roles?.[0]?.id === "152" || this.userDetails?.roles?.[0]?.id === "78"){
      return true;
    }else{
      return false;
    }
  }

  isRM(){  
    if(this.userDetails?.jobRoleId === "3"){
      this.showRMDashboard = true;
    }else{
      this.showRMDashboard = false;
    }
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
